import React from 'react'
import { Container, FullWidthButton } from '../../components/AuthForm.styles'
import { Tonality } from '@dsny/dsny-component-library'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'

export default function SignUpResult({
  dataCy,
  title = '',
  message = '',
  buttonText = '',
  onButtonClick
}) {
  const { t } = useTranslation()
  const theme = useTheme()
  return (
    <Container
      data-cy={dataCy}
      style={{ padding: 0, alignItems: 'flex-start' }}
    >
      {title && (
        <Tonality.UIHeading
          headingStyle="headline4"
          color={theme.colors.neutralW100}
          style={{ marginBottom: 32 }}
        >
          {title}
        </Tonality.UIHeading>
      )}

      {message && (
        <Tonality.UIText textStyle="body" color={theme.colors.neutralW70}>
          {message}
        </Tonality.UIText>
      )}

      <FullWidthButton
        data-cy={dataCy ? `${dataCy}-button` : undefined}
        color="primary"
        setting="player"
        style={{ marginTop: 32, marginBottom: 24 }}
        onClick={onButtonClick}
      >
        {buttonText}
      </FullWidthButton>
    </Container>
  )
}
